import * as React from 'react';
import { COLOR_INDICATORS_FLAG, FeatureFlags, StatusIndicatorBarModel, ThresholdStatus } from '@tableau/metrics-engine';

export interface StatusIndicatorBarProps extends StatusIndicatorBarModel {
  readonly featureFlags: FeatureFlags;
}

export const STATUS_INDICATOR_HEIGHT = 5;

export const StatusIndicatorBar = (props: StatusIndicatorBarProps): React.ReactElement => {
  const backgroundColor = backgroundColorForStatusIndicator(props);
  return (
    <div
      style={{
        width: '100%',
        minHeight: STATUS_INDICATOR_HEIGHT,
        backgroundColor: backgroundColor,
      }}
    />
  );
};

function backgroundColorForStatusIndicator(props: StatusIndicatorBarProps): string | undefined {
  return !props.featureFlags[COLOR_INDICATORS_FLAG] || statusIsNeutralOrUnknown(props.status) ? undefined : props.color;
}

const statusIsNeutralOrUnknown = (status?: ThresholdStatus): boolean => {
  if (!status) {
    return true;
  }
  return status === ThresholdStatus.NEUTRAL || status === ThresholdStatus.UNKNOWN;
};
